import React, { useEffect, useState } from "react";
import BaseURL from "../../../assets/utils/baseUrl";
import MUIDataTable from "mui-datatables";
import { Button, Footer, HeaderAdmin } from "../../../components";
import { TextField } from "@material-ui/core";
import { Loader } from "../../../assets";

function KelolaPad({ setToken }) {
  const [pad, setPad] = useState(null);
  const [modal, setModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(true);
  const [popUp, setPopUp] = useState(false);
  const [success, setSuccess] = useState(true);
  const [load, setLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [alertTahun, setAlertTahun] = useState(false);
  const [alertPajakDaerah, setAlertPajakDaerah] = useState(false);
  const [alertRetribusiDaerah, setAlertRetribusiDaerah] = useState(false);
  const [alertKdYangDipisahkan, setAlertKdYangDipisahkan] = useState(false);
  const [alertLainLainPad, setAlertLainLainPad] = useState(false);
  const [formData, setFormData] = useState({
    tahun: "",
    pajak_daerah: "",
    retribusi_daerah: "",
    kd_yang_dipisahkan: "",
    lain_lain_pad: "",
    created_date: "",
  });
  const [id, setId] = useState("");

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      await fetch(BaseURL + "api/Pad")
        .then((res) => res.json())
        .then((data) => {
          setPad(data.data);
          setLoading(false);
        });
    };
    getData();
  }, [load]);

  const columns = [
    {
      name: "tahun",
      label: "Tahun",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return <div style={{ width: 200 }}>{value}</div>;
        },
      },
    },
    {
      name: "pajak_daerah",
      label: "Pajak Daerah",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "retribusi_daerah",
      label: "Retribusi Daerah",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "kd_yang_dipisahkan",
      label: "Hasil Pengolahan Kekayaan Daerah Yang Dipisahkan",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "lain_lain_pad",
      label: "Lain-lain PAD",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tanggal_post",
      label: "Tanggal Post",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return <div style={{ width: 100 }}>{value}</div>;
        },
      },
    },
    {
      name: "opsi",
      label: "Opsi",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="tooltip btn-hapus-row" onClick={() => hapus(value)}>
                <i className="fas fa-trash-alt"></i>
                <span className="tooltiptext">Hapus</span>
              </div>
              <div
                className="tooltip btn-edit-row"
                onClick={() => {
                  setUpdateModal(true);
                  openUpdateModal(value);
                }}
              >
                <i className="fas fa-edit"></i>
                <span className="tooltiptext">Update</span>
              </div>
            </div>
          );
        },
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: false,
  };

  let tablesData = [];

  if (pad) {
    let date = [];
    for (let i = 0; i < pad.length; i++) {
      let tempDate = "";
      tempDate = pad[i].created_date;
      date = tempDate.split("-");
      if (date[1] != "10") {
        date[1] = date[1].replace("0", "");
      }
      let m = "";
      switch (date[1]) {
        case "1":
          m = "Januari";
          break;
        case "2":
          m = "Februari";
          break;
        case "3":
          m = "Maret";
          break;
        case "4":
          m = "April";
          break;
        case "5":
          m = "Mei";
          break;
        case "6":
          m = "Juni";
          break;
        case "7":
          m = "Juli";
          break;
        case "8":
          m = "Agustus";
          break;
        case "9":
          m = "September";
          break;
        case "10":
          m = "Oktober";
          break;
        case "11":
          m = "November";
          break;
        case "12":
          m = "Desember";
          break;
        default:
          m = "-";
      }
      date = date[2] + " " + m + " " + date[0];
      tablesData.push({
        tahun: pad[i].tahun,
        pajak_daerah: pad[i].pajak_daerah,
        retribusi_daerah: pad[i].retribusi_daerah,
        kd_yang_dipisahkan: pad[i].kd_yang_dipisahkan,
        lain_lain_pad: pad[i].lain_lain_pad,
        tanggal_post: date,
        opsi: pad[i].id_pad,
      });
    }
  }

  const tambah = () => {
    if (formData.tahun == "") {
      setAlertTahun(true);
    } else {
      setAlertTahun(false);
    }

    if (formData.pajak_daerah == "") {
      setAlertPajakDaerah(true);
    } else {
      setAlertPajakDaerah(false);
    }

    if (formData.retribusi_daerah == "") {
      setAlertRetribusiDaerah(true);
    } else {
      setAlertRetribusiDaerah(false);
    }

    if (formData.kd_yang_dipisahkan == "") {
      setAlertKdYangDipisahkan(true);
    } else {
      setAlertKdYangDipisahkan(false);
    }

    if (formData.lain_lain_pad == "") {
      setAlertLainLainPad(true);
    } else {
      setAlertLainLainPad(false);
    }

    if (formData.tahun !== "" && formData.pajak_daerah !== "" && formData.retribusi_daerah !== "" && formData.kd_yang_dipisahkan !== "" && formData.lain_lain_pad !== "") {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "post");
      data.append("tahun", formData.tahun);
      data.append("pajak_daerah", formData.pajak_daerah);
      data.append("retribusi_daerah", formData.retribusi_daerah);
      data.append("kd_yang_dipisahkan", formData.kd_yang_dipisahkan);
      data.append("lain_lain_pad", formData.lain_lain_pad);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", date);

      try {
        fetch(BaseURL + "api/pad", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              tahun: "",
              pajak_daerah: "",
              retribusi_daerah: "",
              kd_yang_dipisahkan: "",
              lain_lain_pad: "",
              created_date: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  const hapus = ($id) => {
    try {
      fetch(BaseURL + "api/pad/" + $id, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then((data) => {
          setLoad(!load);
          if (data.status) {
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setPopUp(true);
        })
        .catch((error) => console.log("Gagal: ", error));
    } catch (error) {
      alert("Terjadi kesalahan pada sistem");
      console.log(error);
    }
  };

  const openUpdateModal = ($id) => {
    const getDataUpdate = async () => {
      await fetch(BaseURL + "api/pad?id=" + $id)
        .then((res) => res.json())
        .then((data) => {
          setFormData({
            tahun: data.data[0].tahun,
            pajak_daerah: data.data[0].pajak_daerah,
            retribusi_daerah: data.data[0].retribusi_daerah,
            kd_yang_dipisahkan: data.data[0].kd_yang_dipisahkan,
            lain_lain_pad: data.data[0].lain_lain_pad,
            created_date: data.data[0].created_date,
          });
          setId($id);
          setModal(true);
        });
    };
    getDataUpdate();
  };

  const update = () => {
    if (formData.tahun == "") {
      setAlertTahun(true);
    } else {
      setAlertTahun(false);
    }

    if (formData.pajak_daerah == "") {
      setAlertPajakDaerah(true);
    } else {
      setAlertPajakDaerah(false);
    }

    if (formData.retribusi_daerah == "") {
      setAlertRetribusiDaerah(true);
    } else {
      setAlertRetribusiDaerah(false);
    }

    if (formData.kd_yang_dipisahkan == "") {
      setAlertKdYangDipisahkan(true);
    } else {
      setAlertKdYangDipisahkan(false);
    }

    if (formData.lain_lain_pad == "") {
      setAlertLainLainPad(true);
    } else {
      setAlertLainLainPad(false);
    }

    if (formData.tahun !== "" && formData.pajak_daerah !== "" && formData.retribusi_daerah !== "" && formData.kd_yang_dipisahkan !== "" && formData.lain_lain_pad !== "") {
      const data = new FormData();
      let today = new Date();
      let date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      data.append("request", "put");
      data.append("id_pad", id);
      data.append("tahun", formData.tahun);
      data.append("pajak_daerah", formData.pajak_daerah);
      data.append("retribusi_daerah", formData.retribusi_daerah);
      data.append("kd_yang_dipisahkan", formData.kd_yang_dipisahkan);
      data.append("lain_lain_pad", formData.lain_lain_pad);
      data.append("id_user", localStorage.getItem("id"));
      data.append("created_date", formData.created_date);
      data.append("updated_date", date);

      try {
        fetch(BaseURL + "api/pad", {
          method: "POST",
          body: data,
        })
          .then((response) => response.json())
          .then((data) => {
            setFormData({
              tahun: "",
              pajak_daerah: "",
              retribusi_daerah: "",
              kd_yang_dipisahkan: "",
              lain_lain_pad: "",
              created_date: "",
            });
            setLoad(!load);
            setModal(false);
            setUpdateModal(false);
            if (data.status) {
              setSuccess(true);
            } else {
              setSuccess(false);
            }
            setPopUp(true);
          })
          .catch((error) => console.log("Gagal: ", error));
      } catch (error) {
        alert("Terjadi kesalahan pada sistem");
        console.log(error);
      }
    }
  };

  return (
    <div className="page">
      <HeaderAdmin title="Kelola PAD" setToken={(e) => setToken(e)} />
      <div className="main-admin">
        <div className="container-admin">
          <div style={{ height: 50 }} />
          <Button
            title="Tambah Post"
            type="primary"
            onClick={() => {
              setUpdateModal(false);
              setModal(true);
            }}
          />
          <div style={{ height: 10 }} />
          {loading ? (
            <div className="loader">
              <img src={Loader}></img>
            </div>
          ) : (
            <MUIDataTable title={"Daftar PAD"} data={tablesData} columns={columns} options={options} download={false} className="table" />
          )}
        </div>
      </div>
      <Footer />

      {/* modal */}
      <div className={modal ? "darker-bg-admin" : "darker-bg-admin hide"}>
        {/* form */}
        <div className="modal-admin">
          <div className="form-admin">
            <TextField type="number" id="tahun" label="Tahun" variant="outlined" style={{ marginTop: 10, marginBottom: 10 }} onChange={(e) => setFormData({ ...formData, tahun: e.target.value })} value={formData.tahun} />
            {alertTahun && <div className="danger-alert">Tahun tidak boleh kosong</div>}

            <TextField
              type="number"
              id="pajak_daerah"
              label="Pajak Daerah"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) => setFormData({ ...formData, pajak_daerah: e.target.value })}
              value={formData.pajak_daerah}
            />
            {alertPajakDaerah && <div className="danger-alert">Pajak Daerah tidak boleh kosong</div>}

            <TextField
              type="number"
              id="retribusi_daerah"
              label="Retribusi Daerah"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) => setFormData({ ...formData, retribusi_daerah: e.target.value })}
              value={formData.retribusi_daerah}
            />
            {alertRetribusiDaerah && <div className="danger-alert">Retribusi Daerah tidak boleh kosong</div>}

            <TextField
              type="number"
              id="kd_yang_dipisahkan"
              label="Hasil Pengolahan Kekayaan Daerah Yang Dipisahkan"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) => setFormData({ ...formData, kd_yang_dipisahkan: e.target.value })}
              value={formData.kd_yang_dipisahkan}
            />
            {alertKdYangDipisahkan && <div className="danger-alert">Hasil Pengolahan Kekayaan Daerah Yang Dipisahkan tidak boleh kosong</div>}

            <TextField
              type="number"
              id="lain_lain_pad"
              label="Lain-lain PAD"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) => setFormData({ ...formData, lain_lain_pad: e.target.value })}
              value={formData.lain_lain_pad}
            />
            {alertLainLainPad && <div className="danger-alert">Lain-lain PAD tidak boleh kosong</div>}
          </div>

          <div style={{ height: 30 }}></div>

          <div className="form-option">
            <Button
              title={updateModal ? "Update" : "Tambah"}
              type="primary"
              onClick={() => {
                if (updateModal) {
                  update();
                } else {
                  tambah();
                }
              }}
            />
            <div style={{ width: 10 }}></div>
            <Button
              title="Batal"
              type="danger"
              onClick={() => {
                setModal(false);
                setUpdateModal(false);
                setFormData({
                  tahun: "",
                  pajak_daerah: "",
                  retribusi_daerah: "",
                  kd_yang_dipisahkan: "",
                  lain_lain_pad: "",
                  created_date: "",
                });
                setAlertTahun(false);
                setAlertPajakDaerah(false);
                setAlertRetribusiDaerah(false);
                setAlertKdYangDipisahkan(false);
                setAlertLainLainPad(false);
              }}
            />
          </div>
        </div>
      </div>

      {/* message pop up */}
      <div className={popUp ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="pop-up-admin">
          <i className={success ? "fas fa-check-circle pop-up-logo" : "fas fa-times-circle pop-up-logo failed-pop-up"}></i>
          {success ? <p>Berhasil</p> : <p className={success ? "" : "failed-pop-up"}>Gagal</p>}
          <div style={{ height: 20 }}></div>
          <Button
            title="Tutup"
            type="primary"
            onClick={() => {
              setAlertTahun(false);
              setAlertPajakDaerah(false);
              setAlertRetribusiDaerah(false);
              setAlertKdYangDipisahkan(false);
              setAlertLainLainPad(false);
              setPopUp(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KelolaPad;
